import { IStore } from '../store.type';

export const selectUserSessionReducer = ({ rootReducer: { userSessionReducer } }: IStore) => {
  return userSessionReducer || {};
};

export const selectUserSession = ({ rootReducer: { userSessionReducer } }: IStore) => {
  return userSessionReducer?.user_session || {};
};

export const selectMessageReducer = ({ rootReducer: { messageReducer } }: IStore) => {
  return messageReducer || {};
};

export const selectNiumForexReducer = ({ rootReducer: { niumForexReducer } }: IStore) =>
  niumForexReducer || {};

export const selectIsNiumForexUser = ({ rootReducer: { niumForexReducer } }: IStore) =>
  niumForexReducer?.isNiumForexUser || false;

export const selectIPBalance = ({ rootReducer: { userSessionReducer } }: IStore) =>
  userSessionReducer?.instapoint_balance || {};

export const selectBusinessPaymentMethods = ({ rootReducer: { userStatusReducer } }: IStore) =>
  userStatusReducer?.businessPaymentMethods || {};

export const niumForexCrossSellingSelector = ({
  rootReducer: {
    niumForexReducer: { niumForexCrossSelling }
  }
}: IStore) => niumForexCrossSelling;
export const getMobileValidationReducer = ({
  rootReducer: { mobileValidationReducer }
}: IStore) => {
  return mobileValidationReducer || {};
};

export const getCountryCode = ({
  rootReducer: {
    userStatusReducer: { country_code }
  }
}: IStore) => {
  return country_code || '';
};

export const getNationality = ({
  rootReducer: {
    userStatusReducer: { nationality }
  }
}: IStore) => {
  return nationality || '';
};

export const getUserStatus = ({
  rootReducer: {
    userStatusReducer: { status }
  }
}: IStore) => {
  return status || '';
};

export const getUserFlowReducer = ({ rootReducer: { userFlowReducer } }: IStore) => {
  return userFlowReducer || {};
};
export const selectTransactionReducer = ({ rootReducer: { transactionReducer } }: IStore) =>
  transactionReducer || {};

export const selectTransactionDetails = ({
  rootReducer: {
    transactionReducer: { transactionDetails }
  }
}: IStore) => transactionDetails || {};

export const selectHelpCenterReducer = ({ rootReducer: { helpCenterReducer } }: IStore) =>
  helpCenterReducer || {};

export const selectUserStatusReducer = ({ rootReducer: { userStatusReducer } }: IStore) =>
  userStatusReducer || {};

export const selectUserDataReducer = ({ rootReducer: { userDataReducer } }: IStore) =>
  userDataReducer || {};

export const selectUiTriggerStateReducer = ({ rootReducer: { uiTriggerState } }: IStore) =>
  uiTriggerState || {};

export const getRfiCmsData = ({
  rootReducer: {
    dashboardReducer: { rfiCmsData }
  }
}: IStore) => {
  return rfiCmsData || {};
};

export const getNewUserFlow = ({ rootReducer: { newUserFlowReducer } }: IStore) =>
  newUserFlowReducer ?? {};

export const getSgkycFlowRfiData = ({
  rootReducer: {
    rfiReducer: { sgKycFlow }
  }
}: IStore) => {
  return sgKycFlow || {};
};

export const selectAuthType = ({ rootReducer: { userStatusReducer } }: IStore) =>
  userStatusReducer?.auth_type || '';

export const selectNewBeneState = ({ rootReducer: { newBeneficiaryReducer } }: IStore) =>
  newBeneficiaryReducer ?? {};

export const selectBankValidationsReducer = ({ rootReducer: { bankValidationsReducer } }: IStore) =>
  bankValidationsReducer || {};

export const selectForms = ({ form }: IStore) => {
  return form || {};
};

export const selectIsShimmering = (
  { rootReducer: { shimmerReducer } }: IStore,
  key: string
): boolean => shimmerReducer?.[key] ?? false;

// we do not need optional chaining here because state and rootReducer will truthy values
export const selectDashboardReducer = ({ rootReducer: { dashboardReducer } }: IStore) =>
  dashboardReducer || {};

export const selectIsRfiBannerVisible = ({ rootReducer: { dashboardReducer } }: IStore): boolean =>
  dashboardReducer?.isRfiBannerVisible ?? false;

export const selectCurrencyConvertor = ({ rootReducer: { transactionReducer } }: IStore) =>
  transactionReducer.currencyCovertor;

export const selectCloseAccountReducer = ({ rootReducer: { closeAccountReducer } }: IStore) =>
  closeAccountReducer;
